/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Toggle_ThemeInputs */

const en_nav_toggle_theme = /** @type {(inputs: Nav_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle theme`)
};

const zh_hans1_nav_toggle_theme = /** @type {(inputs: Nav_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换主题`)
};

const pt_br2_nav_toggle_theme = /** @type {(inputs: Nav_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar tema`)
};

const es_nav_toggle_theme = /** @type {(inputs: Nav_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tema`)
};

const fr_nav_toggle_theme = /** @type {(inputs: Nav_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer de thème`)
};

const de_nav_toggle_theme = /** @type {(inputs: Nav_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design wechseln`)
};

const ru_nav_toggle_theme = /** @type {(inputs: Nav_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить тему`)
};

const it_nav_toggle_theme = /** @type {(inputs: Nav_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia tema`)
};

/**
* | output |
* | --- |
* | "Toggle theme" |
*
* @param {Nav_Toggle_ThemeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_toggle_theme = /** @type {((inputs?: Nav_Toggle_ThemeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Toggle_ThemeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_nav_toggle_theme(inputs)
	if (locale === "pt-BR") return pt_br2_nav_toggle_theme(inputs)
	if (locale === "es") return es_nav_toggle_theme(inputs)
	if (locale === "fr") return fr_nav_toggle_theme(inputs)
	if (locale === "de") return de_nav_toggle_theme(inputs)
	if (locale === "ru") return ru_nav_toggle_theme(inputs)
	if (locale === "it") return it_nav_toggle_theme(inputs)
	return en_nav_toggle_theme(inputs)
});